import { defineMessages } from 'react-intl'

export const lang = defineMessages({
  termsAgree: {
    id: 'donater.form.terms_agree',
    defaultMessage:
      'By clicking “Go to payment”, you accept {terms} and agree that your message must comply with our policies and Twitch’s guidelines. Violating messages may not be displayed on the stream.',
  },
  terms: {
    id: 'donater.form.terms',
    defaultMessage: 'Terms of Use',
  },
})
